import { useEffect, useRef, useState } from 'react';

import { Config } from '../../services/Config';
import type { MicrosostAuthenticationContext } from '../../utils/analytics';

import { useClient } from './useClient';

type MicrosoftCallback = (
  err: any,
  token: string,
  ADAL: MicrosostAuthenticationContext,
  redi: string
) => void;
export function useMicrosoftAuthentication(cb: MicrosoftCallback) {
  const { redirectURL } = useClient();
  const ADAL = useRef<MicrosostAuthenticationContext>();
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [initialized, setInitialized] = useState<boolean>();

  useEffect(() => {
    const handleLoad = () => {
      //@ts-ignore
      ADAL.current = new AuthenticationContext({
        instance: 'https://login.microsoftonline.com/',
        tenant: 'common', //COMMON OR YOUR TENANT ID
        clientId: Config.APPLICATION_AUTH_MICROSOFT_CLIENTID, //This is your client ID
        redirectUri: window.location.origin, //This is your redirect URI
        popUp: true,

        callback: (err: any, token: string) => {
          return cb(err, token, ADAL.current!, redirectURL);
        },
      });
      setInitialized(true);
    };

    // Check if the document is already loaded (e.g., if the script runs after load)
    if (document.readyState === 'complete') {
      handleLoad();
      setInitialized(true);
    } else {
      window.addEventListener('load', handleLoad);
    }

    // Cleanup the event listener when the component unmounts
    return () => {
      window.removeEventListener('load', handleLoad);
    };
  }, [redirectURL]);

  return { ADAL: ADAL.current };
}
